module.exports = __webpack_public_path__ + "img/redemption.bd8c2b64.svg";